import React, { useContext, useState } from "react";
import { IItem } from "../types";
import { DraggableProvided } from "@hello-pangea/dnd";
import { BoardContext } from "../context";

interface ItemProps {
  item: IItem;
  provided: DraggableProvided;
  columnId: string;
  index: number;
}

const Item = (props: ItemProps) => {
  const { item, provided, columnId, index } = props;
  const [isEditing, setIsEditing] = useState(false);
  const { changeItem } = useContext(BoardContext);

  const handleDoubleClick = () => {
    setIsEditing(true);
  };

  const handleBlur = () => {
    setIsEditing(false);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    changeItem(columnId, index, e.target.value);
  };

  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) =>
    e.target.select();

  return (
    <div
      ref={provided.innerRef}
      {...provided.draggableProps}
      {...provided.dragHandleProps}
      className="flex bg-white mt-1 p-2 min-h-4 border border-gray-300 rounded-md select-none"
    >
      {isEditing ? (
        <input
          type="text"
          value={item.content}
          onChange={handleChange}
          onBlur={handleBlur}
          onFocus={handleFocus}
          autoFocus
          className="w-full outline-none"
        />
      ) : (
        <p onDoubleClick={handleDoubleClick}>{item.content}</p>
      )}
    </div>
  );
};

export default Item;
